// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/past_performance.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { CreatePastPerformanceReferenceRequest, CreatePastPerformanceReferenceResponse, GetPastPerformanceReferenceRequest, GetPastPerformanceReferenceResponse, ListPastPerformanceReferencesRequest, ListPastPerformanceReferencesResponse } from "./past_performance_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * PastPerformanceService is the browser edge for SAD-460 / LIB-02: independent
 * internal / partner / historical Past Performance References. Each RPC wraps
 * pangaea's LibraryGatewayService. tenant_id and owner_user_id are always
 * stamped from the resolved viewer identity; reads apply the same
 * libraryItemDenialReason predicate GetLibraryItem / SearchLibraryItems do.
 *
 * @generated from service mono.projectdata.v1.PastPerformanceService
 */ export const PastPerformanceService = {
    typeName: "mono.projectdata.v1.PastPerformanceService",
    methods: {
        /**
     * @generated from rpc mono.projectdata.v1.PastPerformanceService.CreatePastPerformanceReference
     */ createPastPerformanceReference: {
            name: "CreatePastPerformanceReference",
            I: CreatePastPerformanceReferenceRequest,
            O: CreatePastPerformanceReferenceResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.PastPerformanceService.GetPastPerformanceReference
     */ getPastPerformanceReference: {
            name: "GetPastPerformanceReference",
            I: GetPastPerformanceReferenceRequest,
            O: GetPastPerformanceReferenceResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.PastPerformanceService.ListPastPerformanceReferences
     */ listPastPerformanceReferences: {
            name: "ListPastPerformanceReferences",
            I: ListPastPerformanceReferencesRequest,
            O: ListPastPerformanceReferencesResponse,
            kind: MethodKind.Unary
        }
    }
};
